import { MessageService as AbpMessageService } from '@abp/message/message.service';
import { Injectable } from "@angular/core";

@Injectable()
export class MessageService extends AbpMessageService {

    confirmWithResult() {
        // TODO
    }
}
